import { Link } from 'react-router-dom';
import { BrandHeader } from '../components/BrandHeader';
import { SurveyButton } from '../components/SurveyButton';
import type { Language } from '../content/content';
import { content } from '../content/content';

type ThankYouPageProps = {
  language: Language;
};

export function ThankYouPage({ language }: ThankYouPageProps) {
  const copy = content[language];

  return (
    <main className="thanksPage" lang={language}>
      <div className="backgroundArt" aria-hidden="true" />
      <BrandHeader language={language} />
      <section className="thanksPanel" aria-labelledby="thanks-title">
        <p className="eyebrow">{copy.finalQuestion}</p>
        <h1 id="thanks-title">{copy.finalTitle}</h1>
        <p>{copy.finalText}</p>
        <p className="privacyNote">{copy.privacyNote}</p>
        <SurveyButton language={language} />
        <Link className="secondaryButton" to="/">
          {copy.backHome}
        </Link>
        <small>{copy.surveySmallText}</small>
      </section>
    </main>
  );
}
